import { z } from 'zod'
import { ContentfulRichTextDocumentSchema } from './common'
import { ContentfulAssetSchema, ContentfulBynderImageSchema } from './asset'
import { ContentfulCtaSchema, ContentfulBadgeSchema } from './components'

// Legacy Hero Section should be replaced with Component Hero
// need to do this in all contentful envs as well as code
const ContentfulHeroSectionBaseSchema = z.object({
  entryId: z.string().optional(),
  heading: z.string().optional(),
  image: ContentfulAssetSchema.optional(),
  bynderImage: z.array(ContentfulBynderImageSchema).optional(),
  body: ContentfulRichTextDocumentSchema.optional(),
  contentType: z.literal('heroSection'),
})

export const ContentfulHeroSectionSchema = ContentfulHeroSectionBaseSchema.extend({
  variant: ContentfulHeroSectionBaseSchema.optional(),
})

export type ContentfulComponentHero = z.infer<typeof ContentfulComponentHeroSchema>

// Latest Component Hero Schema using new alto style content model
const ContentfulComponentHeroBaseSchema = z.object({
  internalName: z.string().optional(),
  identifier: z.string().optional(),
  image: ContentfulAssetSchema.optional(),
  heading: z.string().optional(),
  subheading: z.string().optional(),
  /** NOTE: comes from contentful as markdown but we transform to rich text for consistency */
  bodyCopy: ContentfulRichTextDocumentSchema.optional(),
  cta: ContentfulCtaSchema.optional(),
  badge: ContentfulBadgeSchema.optional(),
  entryId: z.string().optional(),
  revisionId: z.number().optional(),
  contentType: z.literal('component-hero'),
  bynderImage: z.array(ContentfulBynderImageSchema).optional(),
})

export const ContentfulComponentHeroSchema = ContentfulComponentHeroBaseSchema.extend({
  variant: ContentfulComponentHeroBaseSchema.optional(),
})

export type ContentfulHeroSection = z.infer<typeof ContentfulHeroSectionSchema>

export const ContentfulHeroSchema = z.union([
  ContentfulHeroSectionSchema, // legacy hero section
  ContentfulComponentHeroSchema,
])

export type ContentfulHero = z.infer<typeof ContentfulHeroSchema>
